import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionExpiredDialogService {

  private _visible = new BehaviorSubject<boolean>(false);
  visible$ = this._visible.asObservable();

  private opened = false; 

  open() {
    if (!this.opened) {
      this.opened = true;
      this._visible.next(true);
    }
  }

  close() {
    this.opened = false;
    this._visible.next(false);
  }
}
